import MaterialTable from "components/Table/MaterialTable";
import React, { useState, useEffect } from "react";
import {
  getVotePositionstatus,
  editVotePositionstatus
} from "contexts/API/OPT/Setting";
import { useSweetAlert } from "components/Alert/SweetAlert";
import { useSnackBar } from "components/Alert/Snackbar";

const PositionStatus = props => {
  const { sweetAlerts } = useSweetAlert();
  const { snackBars } = useSnackBar();
  const [data, setData] = useState([]);
  const optionsTable = { pageSize: 10 };
  const [columns] = useState([
    {
      title: "statusId",
      field: "statusId",
      hidden: true
    },
    {
      title: "สถานะการเลือกตั้ง",
      field: "detail",
      cellStyle: {
        minWidth: "700px"
      }
    }
  ]);
  useEffect(() => {
    getVotePositionstatus()
      .then(result => {
        setData(result.data.data);
      })
      .catch(err => {
        sweetAlerts.error("ไม่สามารถดึงข้อมูล", err.toString());
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MaterialTable
      title={"บริหารจัดการประเภท สถานะ หรือสาเหตุตำแหน่ง"}
      options={optionsTable}
      columns={columns}
      data={data}
      editable={{
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              const dataUpdate = [...data];
              const index = oldData.tableData.id;
              dataUpdate[index] = newData;
              editVotePositionstatus(oldData.statusId, newData.detail)
                .then(result => {
                  snackBars.success("แก้ไขข้อมูลเรียบร้อยแล้ว", 3000);
                  setData([...dataUpdate]);
                })
                .catch(err => {
                  const errorMsg = err.response?.data?.desc || err.message || "เกิดข้อผิดพลาด";
                  sweetAlerts.error("ไม่สามารถแก้ไข อปท.", errorMsg);
                });

              resolve();
            }, 1000);
          })
      }}
    />
  );
};
export default PositionStatus;
